import { FLOW_TRIGGER, type FlowTrigger } from '@/lib/api/email-flows';
import MoneyIcon from '@/assets/icons/ic-money.svg';
import CartAbandonedIcon from '@/assets/icons/ic-cart-abandoned.svg';
import FlowsIcon from '@/assets/icons/ic-flows.svg';
import MailIcon from '@/assets/icons/ic-mail.svg';
import LineChartIcon from '@/assets/icons/ic-line-chart.svg';
import { SvgIcon } from '@/types';
import { LuCalendarClock } from 'react-icons/lu';

/**
 * Icon name constants
 * These correspond to SVG files in src/assets/icons/ or react-icons
 */
export const FLOW_ICONS = {
    MONEY: MoneyIcon,
    MEETING: LuCalendarClock,
    CART_ABANDONED: CartAbandonedIcon,
    FLOWS: FlowsIcon,
    MAIL: MailIcon,
    LINE_CHART: LineChartIcon,
} as const;

/**
 * Get the appropriate icon for a flow based on its trigger type
 * Returns icon
 */
export function getFlowIcon(trigger: FlowTrigger): SvgIcon {
    switch (trigger) {
        case FLOW_TRIGGER.TIME:
            return FLOW_ICONS.MEETING;
        case FLOW_TRIGGER.CHECKOUT:
            return FLOW_ICONS.MONEY;
        case FLOW_TRIGGER.CART_ABANDONMENT:
            return FLOW_ICONS.CART_ABANDONED;
        default:
            return FLOW_ICONS.FLOWS;
    }
}

/**
 * Get email icon (used in email list)
 */
export function getEmailIcon(): string {
    return FLOW_ICONS.MAIL;
}

/**
 * Get analytics icon
 */
export function getAnalyticsIcon(): string {
    return FLOW_ICONS.LINE_CHART;
}
